<template>
  <step-item-wrapper @stepManagerState="setFrom">
    <input accept="image/*" id="product-thumbnail" type="hidden" @change="onFileChange"/>

    <div class="my-2">
      <img alt="main-image" class="thumbnail-image" :src="setFeatureImage"/>
    </div>

    <label class="btn btn-primary">
      <span v-t="`product.single.dashboard.product_thumbnail_choose_file_button`"></span>
      <input accept="image/*" type="file" @change="onFileChange" style="display: none;">
    </label>
  </step-item-wrapper>
</template>

<script>
import {defineComponent} from 'vue'
import StepItemWrapper from "../../../StepItemWrapper.vue";
import {defaultProductImage} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default defineComponent({
  name: "StepManagerFormThumbnail1",
  components: {StepItemWrapper},
  data() {
    return {
      defaultProductImage,
      form: {},
    }
  },
  computed: {
    setFeatureImage() {
      let preview = this.form.mainPreview
      let productThumbnail = this.form.mainImage;
      let defaultImage = this.defaultProductImage
      if (preview != null) {
        return preview
      }

      if (productThumbnail == null || Array.isArray(productThumbnail)) {
        return defaultImage
      }
      return productThumbnail
    },
  },
  methods: {
    setFrom(value) {
      this.form = value
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.mainImage = file;
      this.form.mainPreview = URL.createObjectURL(file);
    },
  }
})
</script>

<style scoped>
.thumbnail-image {
  width: auto;
  height: 250px;
  object-fit: contain;
}
</style>